"use client";

import SearchModule from "@/components/search-form/SearchModule";
import MainServices from "./MainServices";
import { usePathname } from "@/i18n/navigation";
import { useHotelQuery } from "@/hooks/url-state/useHotelQuery";
import { useRentalQuery } from "@/hooks/url-state/useRentalQuery";
import { useSpaQuery } from "@/hooks/url-state/useSpaQuery";
import { useActivityQuery } from "@/hooks/url-state/useActivityQuery";
import { getServiceByRoute } from "@/utils/constants/services/serviceCatalog";
import {
  toSearchServiceKey,
  type SearchServiceKey,
} from "@/components/search-form/search.modules.type";
import { useQueryState } from "nuqs";
import { useMemo } from "react";

const SearchPanel = () => {
  const pathname = usePathname();

  const [urlService, setUrlService] = useQueryState("svcType", {
    history: "replace",
  });

  const selectedService: SearchServiceKey =
    (urlService ? toSearchServiceKey(urlService) : undefined) ??
    (getServiceByRoute(pathname)?.key
      ? toSearchServiceKey(getServiceByRoute(pathname)?.key)
      : undefined) ??
    "hotels";

  const { clearSearch: clearHotel } = useHotelQuery();
  const { clearSearch: clearRental } = useRentalQuery();
  const { clearSearch: clearSpa } = useSpaQuery();
  const { clearSearch: clearActivity } = useActivityQuery();

  const clearActionsByService: Record<SearchServiceKey, () => void> = useMemo(
    () => ({
      hotels: () => void clearHotel(),
      rentals: () => void clearRental(),
      spa_msg: () => void clearSpa(),
      tour_act: () => void clearActivity(),
      discover: () => { },
    }),
    [clearHotel, clearRental, clearSpa, clearActivity],
  );

  const handleSelectService = (service: string) => {
    const targetService = toSearchServiceKey(service);
    if (targetService === selectedService) return;

    clearActionsByService[selectedService]?.();

    void setUrlService(targetService === "hotels" ? null : targetService);
  };

  return (
    <>
      <MainServices
        selectedService={selectedService}
        onSelectService={handleSelectService}
      />

      <div className="mt-0 md:mt-4">
        <SearchModule selectedService={selectedService} />
      </div>
    </>
  );
};

export default SearchPanel;
